import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type {
  WaterUserMediaBatchListResponse,
  WaterUserMediaDetail,
  WaterUserMediaItem,
  WaterUserMediaUpdateRequest,
} from '@models/water-user-media-batches';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WaterUserMediaService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/crm/waters`;

  getBatches(waterId: number, page: number, pageSize: number): Observable<WaterUserMediaBatchListResponse> {
    const params = new HttpParams().set('page', page).set('pageSize', pageSize);
    return this.http.get<WaterUserMediaBatchListResponse>(`${this.baseUrl}/${waterId}/media-batches`, { params });
  }

  getBatchMedia(waterId: number, batchId: number): Observable<WaterUserMediaItem[]> {
    return this.http.get<WaterUserMediaItem[]>(`${this.baseUrl}/${waterId}/media-batches/${batchId}/media`);
  }

  getMediaItem(waterId: number, mediaId: number): Observable<WaterUserMediaDetail> {
    return this.http.get<WaterUserMediaDetail>(`${this.mediaUrl(waterId, mediaId)}`);
  }

  updateMedia(waterId: number, mediaId: number, dto: WaterUserMediaUpdateRequest): Observable<WaterUserMediaItem> {
    return this.http.put<WaterUserMediaItem>(`${this.mediaUrl(waterId, mediaId)}`, dto);
  }

  toggleHighlight(waterId: number, mediaId: number): Observable<WaterUserMediaItem> {
    return this.http.post<WaterUserMediaItem>(`${this.mediaUrl(waterId, mediaId)}/highlight`, {});
  }

  approve(waterId: number, mediaId: number): Observable<WaterUserMediaItem> {
    return this.http.post<WaterUserMediaItem>(`${this.mediaUrl(waterId, mediaId)}/approve`, {});
  }

  disapprove(waterId: number, mediaId: number): Observable<WaterUserMediaItem> {
    return this.http.post<WaterUserMediaItem>(`${this.mediaUrl(waterId, mediaId)}/disapprove`, {});
  }

  deleteMedia(waterId: number, mediaId: number): Observable<void> {
    return this.http.delete<void>(`${this.mediaUrl(waterId, mediaId)}`);
  }

  private mediaUrl(waterId: number, mediaId: number): string {
    return `${this.baseUrl}/${waterId}/media/${mediaId}`;
  }
}
